import { ButtonGroup } from '@mui/material';
import { ReactElement } from 'react';
import { MemreButton } from './';

export default function MemreButtonGroup({
  children,
  sx = {},
}: {
  children: Array<ReactElement<typeof MemreButton>>;
  sx: any;
}) {
  return (
    <ButtonGroup sx={sx} variant="text">
      {children}
    </ButtonGroup>
  );
}
